var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var SVGToMesh = require("./../threejsExport/svgToMesh.js");
var cio_config = require("cio-config");

var LineData = function (x1, y1, x2, y2, strokeWidth, color) {
    this.makeObservableTreeNode();

    this.x1 = this.value("x1", true, cio_config.types.float.validator);
    this.x2 = this.value("x2", true, cio_config.types.float.validator);
    this.y1 = this.value("y1", true, cio_config.types.float.validator);
    this.y2 = this.value("y2", true, cio_config.types.float.validator);

    this.strokeWidth = this.value("strokeWidth", true, cio_config.types.positive_float.validator);
    this.color = this.value("color", true);     // if color == null, color is inherited from parent layer

    this.p1 = this.shadow("p1",
        function() { return new lib_geometry.Coord(this.x1(), this.y1()); },
        function(p) { return this.x1(p.x) && this.y1(p.y); },
        [this.x1, this.y1]
    );
    this.p2 = this.shadow("p2",
        function() { return new lib_geometry.Coord(this.x2(), this.y2()); },
        function(p) { return this.x2(p.x) && this.y2(p.y); },
        [this.x2, this.y2]
    );

    this.length = this.shadow("length",
        function () {
            return this.p1().sub(this.p2()).length();
        },
        function (newLength) {
            // update x2,y2 based on current angle and fixed position of x1,y1
            var p1 = this.p1();
            var p2 = this.p2();
            var angle = p2.sub(p1).angle();
            p2 = p1.add(
                new lib_geometry.Coord(
                    newLength*Math.cos(angle),
                    newLength*Math.sin(angle)
                )
            );
            this.p2(p2);
        },
        [this.p1, this.p2]
    );

    this.geometry = this.cachedFunction("geometry",
        this._getGeometry,
        [this.p1, this.p2]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        this._getSegmentedGeometry,
        [this.geometry]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return this.geometry().getBB(); },
        [this.geometry]
    );

    this.pos = this.shadow('pos',
        function() {
            return this.getPos();
        },
        function(val) {
            return this.setPos(val);
        },
        [this.x1, this.y1, this.x2, this.y2]
    );

    this.angle = this.shadow('angle',
        function() {
            return this.p2().sub(this.p1()).angleDegrees();
        },
        function(newAngle) {
            var oldAngle = this.p2().sub(this.p1()).angleDegrees();
            this.rotate(newAngle-oldAngle);
        },
        [this.x1, this.y1, this.x2, this.y2]
    );

    this.width = this.shadow('width',
        function() {
            return this.getWidth();
        },
        function(val) {
            return this.setWidth(val);
        },
        [this.x1, this.y1, this.x2, this.y2]
    );
    this.height = this.shadow('height',
        function() {
            return this.getHeight();
        },
        function(val) {
            return this.setHeight(val);
        },
        [this.x1, this.y1, this.x2, this.y2]
    );

    SVGToMesh.call(this);

    if (x1 != undefined) this.x1(x1);
    else this.x1(0);
    if (x2 != undefined) this.x2(x2);
    else this.x2(0);
    if (y1 != undefined) this.y1(y1);
    else this.y1(0);
    if (y2 != undefined) this.y2(y2);
    else this.y2(0);
    if (strokeWidth != undefined) this.strokeWidth(strokeWidth);
    if (color != undefined) this.color(color);
};
lib_core.mixin(LineData, lib_core.ObservableTreeNode);
module.exports = LineData;

lib_core.JsonParser.registerClass(LineData, "LineData");

LineData.prototype.getSegment = function() {
    return new lib_geometry.Segment(this.p1(), this.p2());
};

LineData.prototype.getLength = function() {
    return this.getSegment().length();
};

LineData.prototype.move = function(diffVec) {
    var p1 = new lib_geometry.Coord(this.x1(), this.y1());
    p1 = p1.add(diffVec);
    this.x1(p1.getX());
    this.y1(p1.getY());

    var p2 = new lib_geometry.Coord(this.x2(), this.y2());
    p2 = p2.add(diffVec);
    this.x2(p2.getX());
    this.y2(p2.getY());
};

LineData.prototype.flip = function (flipline) {
    console.assert(flipline !== undefined); //not implemented
    var p1 = new lib_geometry.Coord(this.x1(), this.y1());
    p1 = p1.flip(flipline);
    this.x1(p1.getX());
    this.y1(p1.getY());

    var p2 = new lib_geometry.Coord(this.x2(), this.y2());
    p2 = p2.flip(flipline);
    this.x2(p2.getX());
    this.y2(p2.getY());
};

LineData.prototype.rotate = function(angle, center) {
    if(center == undefined)
        center = this.pos();

    var p1 = new lib_geometry.Coord(this.x1(), this.y1());
    p1 = p1.rotate(angle, center);
    this.x1(p1.getX());
    this.y1(p1.getY());

    var p2 = new lib_geometry.Coord(this.x2(), this.y2());
    p2 = p2.rotate(angle, center);
    this.x2(p2.getX());
    this.y2(p2.getY());
};

LineData.prototype.getPos = function() {
    return this.p1().add(this.p2()).mult(0.5);
};

LineData.prototype.setPos = function(newPos) {
    var diffVec = newPos.sub(this.getPos());
    this.p1(this.p1().add(diffVec));
    this.p2(this.p2().add(diffVec));
};

LineData.prototype.getWidth = function() {
    return Math.abs(this.p2().sub(this.p1()).getX());
};

LineData.prototype.setWidth = function(newWidth) {
    var widthDiff_2 = (newWidth - this.getWidth()) / 2.0;
    if(this.x1() > this.x2()) {
        this.x1(this.x1() + widthDiff_2);
        this.x2(this.x2() - widthDiff_2);
    } else {
        this.x1(this.x1() - widthDiff_2);
        this.x2(this.x2() + widthDiff_2);
    }
};

LineData.prototype.getHeight = function() {
    return Math.abs(this.p2().sub(this.p1()).getY());
};

LineData.prototype.setHeight = function(newHeight) {
    var heightDiff_2 = (newHeight - this.getHeight()) / 2.0;
    if(this.y1() > this.y2()) {
        this.y1(this.y1() + heightDiff_2);
        this.y2(this.y2() - heightDiff_2);
    } else {
        this.y1(this.y1() - heightDiff_2);
        this.y2(this.y2() + heightDiff_2);
    }
};

LineData.prototype._getGeometry = function() {
    return new lib_geometry.Trace([this.p1(), this.p2()]);
};

LineData.prototype._getSegmentedGeometry = function (precision) {
    return this.geometry().toSegmented(precision);
};
 
